import React, { Component } from "react";
import { RoomContext } from "../context";
import Loading from "./Loading";
import Room from "./Room";
import Title from "./Title";
import styled from "styled-components";

const FeaturedRoomsSection = styled.section`
  padding: 5rem 0;
`;
const FeaturedRoomsCenter = styled.div`
  width: 80vw;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(270px, 1fr));
  grid-row-gap: 2rem;
  grid-column-gap: 40px;
  @media screen and (min-width: 776px) {
    width: 90vw;
    grid-template-columns: repeat(auto-fit, minmax(330px, 1fr));
  }
  @media screen and (min-width: 992px) {
    width: 95vw;
    max-width: 1170px;
  }
`;
export default class FeaturedRooms extends Component {
  static contextType = RoomContext;
  render() {
    let { loading, featuredRooms: rooms } = this.context;
    //console.log(featuredRooms);
    rooms = rooms.map((room) => {
      return <Room key={room.id} room={room} />;
    });
    return (
      <FeaturedRoomsSection>
        <Title title="Featured Rooms" />
        <FeaturedRoomsCenter>
          {loading ? <Loading /> : rooms}
        </FeaturedRoomsCenter>
      </FeaturedRoomsSection>
    );
  }
}
